<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  methods: {
    isTouchEnabled() {
      return "ontouchstart" in window || navigator.msMaxTouchPoints > 0
    }
  },
  created() {
    // If we are on mobile, dont dont do the scrollbar fix as there is no scrollbar
    this.$store.commit("setTouchEnabled", this.isTouchEnabled())
    this.$store.commit("setDevice")
  }
}
</script>
<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
}
body {
  margin: 0px;
  background-color: black;
}
</style>
